import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router";

const PublicRoute = ({ children, ...rest }) => {
  let isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/products",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default PublicRoute;
